import React from 'react';

const JuiceCard = ({ juice, onSelect }) => {
  return (
    <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300">
      <div className="h-48 bg-gradient-to-r from-green-100 to-yellow-50 flex items-center justify-center">
        {juice.image_url ? (
          <img src={juice.image_url} alt={juice.name} className="h-full w-full object-cover" />
        ) : (
          <span className="text-6xl">{juice.emoji}</span>
        )}
      </div>
      <div className="p-5">
        <h3 className="text-xl font-bold text-gray-800 mb-2">{juice.name}</h3>
        <p className="text-gray-600 mb-4">{juice.description}</p>
        <div className="flex justify-between items-center">
          <span className="text-lg font-semibold text-green-600">${juice.price}</span>
          <button 
            onClick={() => onSelect(juice)}
            className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
          >
            Seleccionar
          </button>
        </div>
      </div>
    </div>
  );
};

export default JuiceCard;